/**
 * Light framing for the real product screenshots. Just enough edge to read as
 * a phone or a browser window; the screenshot itself does the storytelling.
 */

const PHONE_ASPECT = '1290 / 2796';
const BROWSER_ASPECT = '2166 / 1858';

export function PhoneFrame({ src, alt, className = '', eager = false }) {
  return (
    <figure className={`phone ${className}`.trim()}>
      <img
        className="phone__screen"
        src={src}
        alt={alt}
        width={1290}
        height={2796}
        style={{ aspectRatio: PHONE_ASPECT }}
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
        fetchPriority={eager ? 'high' : undefined}
      />
    </figure>
  );
}

export function BrowserFrame({ src, alt, url, className = '', eager = false }) {
  return (
    <figure className={`browser ${className}`.trim()}>
      <div className="browser__bar" aria-hidden="true">
        <span className="browser__url">{url}</span>
      </div>
      <img
        className="browser__screen"
        src={src}
        alt={alt}
        width={2166}
        height={1858}
        style={{ aspectRatio: BROWSER_ASPECT }}
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
      />
    </figure>
  );
}
